import type { NetSession } from '../net/session';
import type { NetRole } from '../net/transport';

class NetService {
  public session: NetSession | null = null;
  public role: NetRole = 'offline';

  setSession(session: NetSession, role: 'host' | 'client'): void {
    this.session = session;
    this.role = role;
  }
  isClient(): boolean {
    return this.role === 'client';
  }
  isHost(): boolean {
    return this.role === 'host';
  }
  reset(): void {
    this.session?.close();
    this.session = null;
    this.role = 'offline';
  }
}

export const netService = new NetService();
